export function getThumbnailImage(article) {
	if (article.thumbnail) {
		return article.thumbnail;
	}
	if (article.thumbnailIndex){
		return article.images[article.thumbnailIndex];
	}
	return article.images[0];
}